const isEmptyArray = (arr = []) => {
  if (!Array.isArray(arr)) {
    return true
  }

  return arr?.every((element) => !element || element === '')
}

const getHeaderTitles = (items) => {
  if (typeof items[0][1] === 'string') {
    return [items[0][1]]
  }

  const filteredItems = items?.filter(
    (item) => !isEmptyArray(item?.props?.children)
  )

  return filteredItems?.map((item) =>
    item?.props?.children?.find((text) => typeof text === 'string')
  )
}

export default getHeaderTitles
